import React, { useState, useEffect } from "react";
import { Spinner, Alert } from "react-bootstrap";

const AboutSection = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch("https://ecom-22-fe6311cae608.herokuapp.com/api/about-section");
        const data = await response.json();
        
        if (data.success) {
          setAboutData(data.data);
        } else {
          setError(data.message || "Failed to fetch about section data");
        }
      } catch (err) {
        setError("Network error. Please try again later.");
        console.error("Error fetching about section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <section className="service-area service-area-v1">
        <div className="container-1350">
          <div className="service-wrapper pt-75 pb-40">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="service-area service-area-v1">
        <div className="container-1350">
          <div className="service-wrapper pt-75 pb-40">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <Alert variant="danger">{error}</Alert>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!aboutData || !aboutData.isActive) {
    return null; // Don't render if data is not available or section is inactive
  }

  return (
    <>
      <section 
        className="service-area service-area-v1"
        style={aboutData.backgroundImage ? { 
          backgroundImage: `url(${aboutData.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        } : {}}
      >
        <div className="container-1350">
          <div className="service-wrapper pt-75 pb-40">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="section-title text-center mb-55 wow fadeInUp">
                  <h2>{aboutData.title}</h2>
                  <p>{aboutData.subtitle}</p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              {aboutData.features.map((feature, index) => (
                <div key={feature.id || index} className="col-lg-4 col-md-6 col-sm-12">
                  <div
                    className="service-item service-style-two mb-40 wow fadeInUp"
                    data-wow-delay={`.${15 + index * 5}s`}
                  >
                    <div className="icon">
                      <i className={feature.icon} />
                    </div>
                    <div className="text">
                      <h3 className="title">{feature.title}</h3>
                      <ul className="list-style-two">
                        {feature.points.map((point, pointIndex) => (
                          <li key={pointIndex}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;